import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import c from 'classnames';
import { ListType } from '../../apis/dumpert';
import {
  batchFetchOp,
  selectItemsListNeedsToBeLoaded,
  selectItemsListParams,
  selectShowNsfw,
  selectSearchDefaultSort,
} from '../../ducks';
import { useDispatch, useSelector } from 'react-redux';
import { StickySidebar } from '../stickysidebar';
import { ItemsListLazyLoad, ItemsListSidebar } from '../itemslist';
import { useCurrentBreakPoint } from '../commons';
import { getValidItemId } from '../paths';
import { adBreakPoint } from '../../lib/helpers';
import { ScrollToTopButton } from '../scrolltotop';

export const Tag = () => {
  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const listType = params.listType;
  const showNsfw = useSelector(selectShowNsfw);
  const searchSorting = useSelector(selectSearchDefaultSort);
  const listLoad = useSelector(state => selectItemsListNeedsToBeLoaded(state, listType));
  const { tagId } = useSelector(state => selectItemsListParams(state, listType));
  const toppersLoad = useSelector(state => selectItemsListNeedsToBeLoaded(state, ListType.toppers));
  const latestLoad = useSelector(state => selectItemsListNeedsToBeLoaded(state, ListType.latest));
  const currentBreakPoint = useCurrentBreakPoint();

  const [currentSearchSorting, setSearchSorting] = useState(useSelector(selectSearchDefaultSort));
  const [currentShowNsfw, setShowNsfw] = useState(useSelector(selectShowNsfw));

  useEffect(() => {
    const lists = [];
    const searchSortingIsUpdated = () => searchSorting !== currentSearchSorting;
    const nsfwIsUpdated = () => showNsfw !== currentShowNsfw;

    if (listLoad || tagId !== params.tagId || nsfwIsUpdated() || searchSortingIsUpdated()) {
      lists.push({ type: listType, params: { ...params, sorting: searchSorting } });
    }
    if (toppersLoad || nsfwIsUpdated()) {
      lists.push({ type: ListType.toppers, params: {} });
    }
    if (latestLoad || nsfwIsUpdated()) {
      lists.push({ type: ListType.latest, params: {} });
    }
    if (lists.length) {
      dispatch(batchFetchOp({ items: [], lists }));
    }
    setSearchSorting(searchSorting);
    setShowNsfw(showNsfw);
  }, [params.tagId, searchSorting, showNsfw]);

  return (
    <>
      <div className={c(
        'grid',
        { ['three']: ['M'].includes(adBreakPoint(currentBreakPoint)) },
        { ['four']: ['L', 'XL'].includes(adBreakPoint(currentBreakPoint)) },
      )}>
        <main className={c(
          { ['two-third']: ['M'].includes(adBreakPoint(currentBreakPoint)) },
          { ['three-fourth']: ['L', 'XL'].includes(adBreakPoint(currentBreakPoint)) },
        )}>
          <ItemsListLazyLoad
            typeOfList={listType}
            params={params}
            history={history}
            emptySearch={params.listType === 'zoek' && !tagId}
          />
        </main>
        {['M', 'L', 'XL'].includes(adBreakPoint(currentBreakPoint)) && (
          <aside
            className={c(
              { ['third']: ['M'].includes(adBreakPoint(currentBreakPoint)) },
              { ['fourth']: ['L', 'XL'].includes(adBreakPoint(currentBreakPoint)) },
            )}
            data-type={'sidebar'}
          >
            <StickySidebar>
              <ItemsListSidebar
                typeOfList={ListType.toppers}
                numOfItems={5}
              />
              <div className={'spacer'}></div>
              <ItemsListSidebar
                typeOfList={ListType.latest}
                numOfItems={5}
              />
            </StickySidebar>
          </aside>
        )}
      </div>
      <ScrollToTopButton />
    </>
  );
};

Tag.serverFetch = ({ params }, staticContext) => batchFetchOp({
  items: [].concat(getValidItemId(staticContext.request.query.selectedId) || []),
  lists: [
    { type: params.listType, params },
    { type: ListType.toppers, params: {} },
    { type: ListType.latest, params: {} },
  ],
});
